import clear from '../../common/array/clear';
import CustomDataSourceFields from '../../../../types/report/CustomDataSourceFields';
import declarationValidator from './declarationValidator';
import IngestionConfig from '../../../../types/ingestion/IngestionConfig';
import Lookup from '../../../../types/functions/Lookup';
import ReportFieldDefinition from '../../../../types/report/ReportFieldDefinition';
import ReportVariable from '../../../../types/report/ReportVariable';
import stringHelper from '../../common/stringHelper';
import uniquenessValidator from './uniquenessValidator';
import Dictionary from '../../../../types/report/Dictionary';
import UserDefinedFunction from '../../../../types/report/UserDefinedFunction';
import ErrorType from '../../../../types/report/ErrorType';
import Mode from '../../../../types/report/Mode';

const maxNameCharacters = 50;

const validateVariable = (variable: ReportVariable, functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], variables: ReportVariable[], lookups: Lookup[], dictionaries: Dictionary[],
    dataSources: IngestionConfig[], reportFields: ReportFieldDefinition[], customDataSourceFields: CustomDataSourceFields, reportType: string): void => {

    clear(variable.errors);

    let metadataError = validateMetadata(variable.name);
    if (metadataError) {
        variable.errors.push(metadataError);
    }
    if (variable.mode === Mode.Local) {

        declarationValidator.validate(variable, functions, globalFunctions, lookups, dictionaries, variables, dataSources, reportFields, customDataSourceFields, variable.dataType, null, false, reportType);
    }
};

const validateMetadata = (name: string): string | null => {

    if (stringHelper.isEmpty(name)) {
        return 'Variable name is required';
    }

    if (name.length > maxNameCharacters) {
        return `Variable name max character count is ${maxNameCharacters}`;
    }

    return null;
};

const validate = (variables: ReportVariable[], functions: UserDefinedFunction[], globalFunctions: UserDefinedFunction[], lookups: Lookup[], dictionaries: Dictionary[],
    dataSources: IngestionConfig[], reportFields: ReportFieldDefinition[], customDataSourceFields: CustomDataSourceFields, reportConfigType:string): ErrorType => {

    variables.forEach(x => validateVariable(x, functions, globalFunctions, variables, lookups, dictionaries, dataSources, reportFields, customDataSourceFields, reportConfigType));

    uniquenessValidator.validate(variables, v => v.name, 'Variable', 'name');

    let variableWithError = variables.find(x => x.errors.length > 0);

    return {
        message: variableWithError ? 'Invalid variable(s)' : '',
        componentNumber: variableWithError?.number
    };
};

const variableValidator = {
    validate,
    validateVariable,
    validateMetadata
};

export default variableValidator;
